import { useCallback, useEffect } from 'react';
import { ROUTES } from '@routing/routes';
import { AppFCC } from '@types';
import { currentMemberGetRoleType } from '@selectors/current-member';
import { useNavigator } from '@hooks/routing';
import { useTypedSelector } from '@hooks/store';
import { _RoleAccessControlProps, RoleAccessControlProps } from './types';
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const _RoleAccessControl: AppFCC<_RoleAccessControlProps> = props => {
  const {
    children,
    roleType,
    callback,
    allowedRoleTypes,
    disallowedRoleTypes
  } = props;
  useEffect(() => {
    if (allowedRoleTypes) {
      if (allowedRoleTypes.includes(roleType)) {
        return;
      }
      callback();
      return;
    }
    if (disallowedRoleTypes?.includes(roleType)) {
      callback();
    }
  }, [roleType, allowedRoleTypes, disallowedRoleTypes, callback]);
  if (allowedRoleTypes) {
    if (allowedRoleTypes.includes(roleType)) {
      return _jsx(_Fragment, {
        children: children
      });
    }
    return null;
  }
  if (disallowedRoleTypes?.includes(roleType)) {
    return null;
  }
  return _jsx(_Fragment, {
    children: children
  });
};
export const RoleAccessControl: AppFCC<RoleAccessControlProps> = props => {
  const {
    children,
    callback,
    allowedRoleTypes,
    disallowedRoleTypes
  } = props;
  const roleType = useTypedSelector(currentMemberGetRoleType);
  const navigator = useNavigator();
  const redirect = useCallback(() => {
    navigator.navigate(ROUTES.index.getDescriptor());
  }, [navigator]);
  return _jsx(_RoleAccessControl, {
    roleType: roleType,
    callback: callback ?? redirect,
    allowedRoleTypes: allowedRoleTypes,
    disallowedRoleTypes: disallowedRoleTypes,
    children: children
  });
};